import { createFileRoute } from '@tanstack/react-router'
import { researchDiscoveryRouteKernel } from '~/features/research-workspace/route-kernels'

export const Route = createFileRoute('/research/')({
  ...researchDiscoveryRouteKernel,
})
